import { Form, Select, Input, Button } from "antd";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import { useInvitacionJurados } from "../../../hooks/useInvitacionJurados";
import { ModalExito } from "./modalexito.view";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";

export const InvitacionJurados = () => {
  const {
    invitacion,
    setInvitacion,
    enviarInvitacion,
    openModal,
    setOpenModal,
  } = useInvitacionJurados();

  let fields = [
    {
      name: "invitacion_profesional",
      value: invitacion.invitacion_profesional,
    },
    { name: "nombre_completo", value: invitacion.nombre_completo },
    { name: "correo", value: invitacion.correo },
  ];
  const routes = [
    { nombre: "Gestión jurados" },
    { nombre: "Inscripción extemporánea" },
  ];

  return (
    <div>
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-4 pe-4">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Invitación a la inscripción extemporánea de jurado
        </div>
        <div className="sombra_card" style={{ marginBottom: "50px" }}>
          <div className="header_card">
            <div className="title_in_card font-size-14px font-color-4B4B4B  font-family-Montserrat-Regular">
              {" "}
              Formulario de invitación -{" "}
              <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828">
                Todos los campos son obligatorios
              </span>
            </div>
          </div>
          <div className="body_card">
            <div className="col-12">
              <Form
                name="formInvitacionJurados"
                size="large"
                fields={fields}
                onFinish={enviarInvitacion}
                onFieldsChange={(_, fields: any) => {
                  let infoupdate: any = { ...invitacion };
                  for (const i in fields) {
                    infoupdate[fields[i].name] = fields[i].value;
                  }
                  setInvitacion(infoupdate);
                }}
              >
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3 order-1">
                    <span className="width-100 font-family-Montserrat-SemiBold font-size-12px pb-2 container-span-titulos-bottom font-color-4B4B4B">
                      Invitación a profesional
                    </span>
                    <Form.Item
                      className="no-margin"
                      name="invitacion_profesional"
                      rules={[
                        {
                          required: true,
                          message: "Seleccione una invitación",
                        },
                      ]}
                    >
                      <Select
                      suffixIcon={<FlechaSelect />}
                        placeholder="Seleccionar..."
                        value={invitacion.invitacion_profesional}
                      >
                        <Select.Option value={1}>Interno</Select.Option>
                        <Select.Option value={0}>Externo</Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-12 col-lg-6 order-0">
                    <span className="width-100 font-family-Montserrat-SemiBold font-size-12px pb-2 container-span-titulos-bottom font-color-4B4B4B">
                      Nombre completo
                    </span>
                    <Form.Item
                      className="no-margin"
                      name="nombre_completo"
                      rules={[
                        {
                          required: true,
                          message: "Digite su nombre completo",
                        },
                      ]}
                    >
                      <Input value={invitacion.nombre_completo} />
                    </Form.Item>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 order-3">
                    <span className="width-100 font-family-Montserrat-SemiBold font-size-12px pb-2 container-span-titulos-bottom font-color-4B4B4B">
                      Correo
                    </span>
                    <Form.Item
                      className="no-margin"
                      name="correo"
                      rules={[
                        { required: true, message: "Digite su correo" },
                        { type: "email", message: "No es un correo válido" },
                      ]}
                    >
                      <Input value={invitacion.correo} />
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
          <div className="footer_card">
            <div className="d-flex justify-content-end ">
              <Button
                className="button-azul-radius m-0"
                form="formInvitacionJurados"
                htmlType="submit"
              >
                Enviar invitación
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ModalExito
        openModal={openModal}
        setOpenModal={setOpenModal}
        nombreInvitacion={invitacion.nombre_completo}
      />
    </div>
  );
};
